export default __webpack_public_path__ + "static/media/googleStore.596e8c6d.png";